"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsList.title': 'Agenti di Comunicazione',
    'whatsapp.settingsList.add': 'Aggiungi numero di telefono',
    'whatsapp.settingsList.empty': 'Nessun numero configurato. Aggiungine uno per iniziare.',
    'whatsapp.settingsList.language': 'Lingua',
    'whatsapp.settingsList.avatar': 'Avatar',
    'whatsapp.settingsList.actions': 'Azioni',
    'whatsapp.settingsList.loadFailed': 'Impossibile caricare le configurazioni WhatsApp.',
    'whatsapp.settingsList.deleteConfirm': 'Sei sicuro di voler eliminare questa configurazione WhatsApp?',
    'whatsapp.settingsList.deleted': 'Configurazione WhatsApp eliminata.',
    'whatsapp.settingsList.deleteFailed': 'Impossibile eliminare la configurazione WhatsApp.',
};
